import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import '../src/components/GlobalStyle.css';

// import { ScrollToTop } from '../src/components/ScrollToTop'
import Home from "./pages/Home";

import ChannelSales from "./pages/ChannelSales";
import SalesContests from "./pages/SalesContests";
import Referrals from "./pages/Referrals";
import Rebates from "./pages/Rebates";
import Payments from "./pages/Payments";
import EbikeIncentives from "./pages/EbikeIncentives";
import CustomIncentivePrograms from "./pages/CustomIncentivePrograms";

import Technology from "./pages/Technology";
import SupportServices from "./pages/SupportServices";
import VisaPrepaidCards from "./pages/VisaPrepaidCards";
import EGiftCards from "./pages/EGiftCards";
import CardOrdering from "./pages/CardOrdering";

import About from "./pages/About";
import FAQs from "./pages/FAQs";

import KnowledgeCenter from "./pages/KnowledgeCenter";

import Blog from "./components/KnowledgeCenterComponents/Blog";
import BlogPost from "./components/KnowledgeCenterComponents/BlogPost";

import ScheduleDemo from "./pages/ScheduleDemo";

import { ApolloProvider } from "@apollo/client";
import { ApolloClient } from '@apollo/client';
import { InMemoryCache } from '@apollo/client';
//import { createHttpLink } from 'apollo-link-http';
/*import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { split } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { createUploadLink } from "apollo-upload-client";
import { ApolloLink } from 'apollo-link';*/

import { GraphQLWsLink } from "@apollo/client/link/subscriptions"
import { createClient } from "graphql-ws"

import globals from './_helpers/globals';
import AnthonyContact from './landingpages/AnthonyContact';
import GinaContact from './landingpages/GinaContact';
import ThaliaContact from './landingpages/ThaliaContact';
import ColtonContact from './landingpages/ColtonContact';

const client = new ApolloClient({
  uri: globals.GRAPHQL_ENDPOINT, // Replace with your GraphQL endpoint
  cache: new InMemoryCache(),
});

function App() {
  return (
    <>
      <ApolloProvider client={client}>
        <BrowserRouter>
          {/* <ScrollToTop /> */}
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/channel-sales" element={<ChannelSales />} />
            <Route path="/sales-contests" element={<SalesContests />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/rebates" element={<Rebates />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/ebike-incentives" element={<EbikeIncentives />} />
            <Route path="/custom-incentive-programs" element={<CustomIncentivePrograms />} />

            <Route path="/technology" element={<Technology />} />
            <Route path="/support-services" element={<SupportServices />} />
            <Route path="/visa-prepaid-cards" element={<VisaPrepaidCards />} />
            <Route path="/egift-cards" element={<EGiftCards />} />
            <Route path="/card-ordering" element={<CardOrdering />} />

            <Route path="/about" element={<About />} />
            <Route path="/faqs" element={<FAQs />} />

            <Route path="/knowledge-center" element={<KnowledgeCenter />} />

            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:page" element={<Blog />} />
            <Route path="/blog/posts/:post" element={<BlogPost />} />

            <Route path="/schedule-demo" element={<ScheduleDemo />} />

            <Route path="/Anthony-Gennette" element={<AnthonyContact />} />
            <Route path="/Gina-Gennette" element={<GinaContact />} />
            <Route path="/Thalia-Vangel" element={<ThaliaContact />} />
            <Route path="/Colton-Knutson" element={<ColtonContact />} />

          </Routes>
        </BrowserRouter>
      </ApolloProvider>
    </>
  );
}

export default App;
